import Axios from 'axios';
import { ISubscriptionImage, ISubscriptionImageResponse } from 'models/login';
import { Common } from 'utils/constants';
import { StandardResponse, createStandardResponse } from '../../models/standard-response';
import BaseService from '../base-service';
import type {
  IChangeEmailRequest,
  IEmailVerificationRequest,
  IInitiateEmailChangeResponse,
  IPartnerPromotion,
  IUpdateProfileRequest,
  IUserData,
} from 'models/profile';
import { env } from 'config/env';

export const getProfile = async (): Promise<StandardResponse<IUserData>> => {
  try {
    const data = {
      platform_type: Common.PlatformType.WEB,
    };
    const res = await BaseService({
      url: `/driver/detail`,
      method: 'POST',
      data,
    });
    return createStandardResponse<IUserData>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const updateProfile = async (data: IUpdateProfileRequest): Promise<StandardResponse<Array<number>>> => {
  try {
    const res = await BaseService({
      url: `/driver`,
      method: 'PUT',
      data,
    });
    return createStandardResponse<Array<number>>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const deleteAccount = async (): Promise<StandardResponse<null>> => {
  try {
    const res = await BaseService({
      url: `/driver/cancel`,
      method: 'DELETE',
    });
    return createStandardResponse<null>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getParentPromotionById = async (
  id: number,
  driver_id: number,
  session_id: string,
): Promise<StandardResponse<IPartnerPromotion>> => {
  try {
    const res = await BaseService({
      url: session_id
        ? `/driver/partner-promotion/${id}/${driver_id}/${session_id}`
        : `/driver/partner-promotion/${id}/${driver_id}`,
      method: 'get',
      data: { byPassAuth: true },
    });
    return createStandardResponse<IPartnerPromotion>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getConfigurationDetail = async (data: { code: string }) => {
  try {
    const res = await Axios.post(
      `${env.VITE_API_SERVER}/${env.VITE_API_VERSION}/driver/public/configuration/search`,
      data,
    );
    return Promise.resolve(res.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getSubscriptionImage = async (
  data: ISubscriptionImage,
): Promise<StandardResponse<ISubscriptionImageResponse>> => {
  try {
    const res = await BaseService({
      url: `driver/premium-subscriptions/image`,
      method: 'POST',
      data: { byPassAuth: true, ...data },
    });

    return createStandardResponse<ISubscriptionImageResponse>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const initiateEmailChange = async (
  data: IChangeEmailRequest,
): Promise<StandardResponse<IInitiateEmailChangeResponse>> => {
  try {
    const res = await BaseService({
      url: `/driver/change-email`,
      method: 'POST',
      data,
    });
    return createStandardResponse<IInitiateEmailChangeResponse>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const verifyEmailChange = async (data: IEmailVerificationRequest): Promise<StandardResponse<number>> => {
  try {
    const res = await BaseService({
      url: `/driver/verify-otp`,
      method: 'PUT',
      data,
    });
    return createStandardResponse<number>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};
